import React, { useState } from "react";
import { IconZoomIn } from "@tabler/icons-react";
import axios from "../../../library/axios";
import { Base64ViewerComp } from "../../";
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const ListDocumentForumComp = (props) => {
  const baseUrl = new URL(window.location.href);
  const [link, setLink] = useState("");
  const [isPdf, setisPdf] = useState("application/pdf");
  const [lgShowIframe, setLgShowIframe] = useState(false);

  const downloadFile = (url, fileName) => {
    const concatUrl = baseUrl.origin.concat(`/${url}`);
    const link = document.createElement("a");
    link.href = concatUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const handleShowDocument = async (id) => {
    try {
      setLink("");
      const options = {
        url: `/skor/show-dokumen/${id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      if (data.data.mimeType !== isPdf) {
        downloadFile(data.data.link, data.data.namaFile);
        return false;
      }
      const concatUrl = baseUrl.origin.concat(`/${data.data.link}`);
      setLgShowIframe(true);
      setLink(concatUrl);
    } catch (err) {
      setLgShowIframe(false);
      console.log(err.message);
    }
  };

  return (
    <>
      <table className="table table-row-dashed table-row-gray-300 gy-7">
        <thead className="bg-primary text-white">
          <tr className="fw-bolder fs-6">
            <th className="text-center">Aksi</th>
            <th className="text-center">Nama File</th>
          </tr>
        </thead>
        <tbody>
          {props?.documents?.map((document) => (
            <tr>
              <td className="text-center">
                <button
                  onClick={() => handleShowDocument(document.id)}
                  className="btn btn-primary btn-sm"
                  type="button"
                >
                  <IconZoomIn stroke={2} /> Download File
                </button>
              </td>
              <td>
                {document.namaFile}
                <br></br>
                <i className="fs-8">
                  {document.createdAt} by {document.createdBy}
                </i>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {lgShowIframe === true ? (
        <Base64ViewerComp link={link} close={() => setLgShowIframe(false)} />
      ) : (
        ""
      )}
    </>
  );
};

export default ListDocumentForumComp;
